import { render } from "./godsMortals.vue?vue&type=template&id=7c8b95f2&scoped=true"
import script from "./godsMortals.vue?vue&type=script&lang=js"
export * from "./godsMortals.vue?vue&type=script&lang=js"

import "./godsMortals.vue?vue&type=style&index=0&id=7c8b95f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8b95f2"]])

export default __exports__